import { FC } from "react";
import StandardModal from "./StandardModal";

interface StandardModalBemVindoPayProps {
  showModal: boolean;
  onCloseModal: () => void;
  onPrimaryButtonClick?: () => void;
}

const StandardModalBemVindoPay: FC<StandardModalBemVindoPayProps> = ({
  showModal,
  onCloseModal,
  onPrimaryButtonClick,
}) => {
  const handleIniciarConfiguracao = () => {
    onCloseModal();

    if (onPrimaryButtonClick) {
      onPrimaryButtonClick();
    }
  };

  return (
    <>
      <StandardModal
        showModal={showModal}
        onCloseModal={onCloseModal}
        videoSrc="https://www.youtube.com/watch?v=gcmdb2f3RIU"
        topBar="Bem vindo(a) ao Group Pay!"
        titulo="🚀 Configure e comece a usar o Group Pay!"
        tituloStyle={{
          fontSize: "1vw",
          fontWeight: "bold",
          color: "#2F4050",
          textAlign: "left",
          marginBottom: "1vw",
        }}
        conteudoPrimario={
          <p
            style={{
              fontSize: "0.85vw",
              lineHeight: "1.2",
              marginBottom: "1vw",
              color: "#2F4050",
            }}
          >
            Antes de começar a configuração, <strong>assista ao vídeo acima e siga os 3 passos rápidos</strong> para
            ativar: <br />
            <br />
            <strong>1. Ative os condomínios</strong> que irão utilizar o Group Pay. <br />
            <strong>2.</strong> Configure a <strong>busca externa</strong> para ampliar a captura de documentos. <br />
            <strong>3.</strong> Configure a <strong>busca por e-mail</strong> para automatizar a coleta das notas
            fiscais. <br />
          </p>
        }
        conteudoSecundario={
          <div style={{ textAlign: "left" }}>
            <p
              style={{
                fontSize: "0.85vw",
                lineHeight: "1.2",
                marginBottom: "1vw",
                color: "#2F4050",
              }}
            >
              Tudo isso leva poucos minutos e vai transformar sua rotina!
            </p>
          </div>
        }
        footerPrimaryLabel="Iniciar configuração"
        footerPrimaryVariant="primary"
        onFooterPrimaryClick={handleIniciarConfiguracao}
        footerSecondaryVariant="outline-primary"
        size="sm"
        fecharModalAoClicarFora={false}
        containerStyle={{ margin: 0, paddingLeft: "1vw", textAlign: "left" }}
      />
    </>
  );
};

export default StandardModalBemVindoPay;
